module.exports = __webpack_public_path__ + "static/media/Fae4.78e91e7b.png";